import React from "react";
import { Link } from "react-router-dom";
import "./Service.css";

import img3002 from "../images/service-fluid/3002/FF3002_025_front.png";
import img4211 from "../images/service-fluid/4211/4211_5front.webp";
import img4212 from "../images/service-fluid/4212/4212_1front.webp";
import img4213 from "../images/service-fluid/4213/4213_1front.webp";


const serviceSections = [
  {
    id: "service",
    title: "Service Fluids",
    products: [
      { id: "3002", name: "FANFARO Dot-4 Brake Fluid 3002", image: img3002 },
      { id: "4211", name: "FF Coolant G11 4211", image: img4211 },
      { id: "4212", name: "FANFARO Coolant G12+ 4212", image: img4212 },
      { id: "4213", name: "FANFARO Coolant G13 4213", image: img4213 },
    ],
  },
];

const Service = () => {
  return (
    <>
      <div className="car-v4-page">
        <br />

        {/* Breadcrumb */}
        <nav className="app-breadcrumb">
          <Link to="/">Home</Link>
          <span className="separator">›</span>
          <Link to="/products">Products</Link>
          <span className="separator">›</span>
          <span className="current">
            Operating & Service Fluids
          </span>
        </nav>

        {/* Sections */}
        {serviceSections.map((section) => (
          <section key={section.id} className="car-v4-section">
            <h2 className="car-v4-heading">{section.title}</h2>

            <div className="car-v4-grid">
              {section.products.map((product) => (
                <Link
                  key={product.id}
                  to={`/products/operating-service-fluids/service-fluids/service/${section.id}/${product.id}`}
                  className="car-v4-card"
                >
                  <div className="car-v4-img">
                    <img src={product.image} alt={product.name} />
                  </div>

                  <div className="car-v4-content">
                    <span className="car-v4-name">
                      {product.name}
                    </span>
                    <span className="car-v4-arrow-wrap">
                      <span className="car-v4-arrow">→</span>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
};

export default Service;